module.exports = __webpack_public_path__ + "static/67invgde-cbfb3d5667cad2c0b8d6c54682a1ba8c.gif";